import { CargaBForm, CargaBInfo } from "./components";

export const CargaB20 = ({ showButtons, setShowButtons }) => {
  if (!showButtons.infoTable) return <CargaBForm />;
  return <CargaBInfo />;
};
